var lists_default = {
  "fontElementMap": "oSRB5",
  "orderedlist": "-wuhD",
  "bulletedlist": "ggbv-",
  "listItem": "_8T5i3"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
